module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"head":{"meta":{"description":"TODO:このページの説明文をここに記述する(※Googleの検索結果に表示されるのでよく考える事!)"}},"label":{"deadline":"Deadline","period":"Period","days":"Days","days_data":"%{days} days","location":"Location","details":"Details","head_office":"Head office"}}}')
  delete Component.options._Ctor
}
